import { makeLocalUrl } from '@trello/urls';
import genericNormalizer, { normalizeDate } from './generic';
import { membershipsFromResponse } from './memberships';

// eslint-disable-next-line no-restricted-imports
import {
  BoardBackgroundModel,
  BoardCreationMethod,
  BoardModel,
  BoardPreferencesModel,
  BoardStarModel,
} from 'app/gamma/src/types/models';

// eslint-disable-next-line no-restricted-imports
import {
  BoardResponse,
  BoardResponsePrefs,
  MemberBoardStar,
} from 'app/gamma/src/types/responses';

import { normalizeBackgroundImagePreviews } from './image-preview';

// eslint-disable-next-line @trello/no-module-logic
export const normalizeBoardBackgroundPrefs = genericNormalizer<
  BoardResponsePrefs,
  BoardBackgroundModel
>(({ from, has }) => ({
  backgroundBottomColor: from('backgroundBottomColor'),
  backgroundBrightness: from('backgroundBrightness'),
  backgroundTopColor: from('backgroundTopColor'),
  backgroundTile: from('backgroundTile'),
  backgroundImage: from('backgroundImage'),
  backgroundImageScaled: has(
    'backgroundImageScaled',
    normalizeBackgroundImagePreviews,
  ),
}));

// eslint-disable-next-line @trello/no-module-logic
export const normalizeBoardPrefs = genericNormalizer<
  BoardResponsePrefs,
  BoardPreferencesModel
>(({ from }) => ({
  cardCovers: from('cardCovers'),
  permissionLevel: from('permissionLevel'),
  comments: from('comments'),
  isTemplate: from('isTemplate'),
}));

function maxDate(
  newDateString?: string,
  previousDate?: Date | null,
): Date | undefined {
  if (newDateString !== undefined) {
    const newDate = normalizeDate(newDateString);

    if (!previousDate || newDate > previousDate) {
      return newDate;
    }
  }

  return previousDate ?? undefined;
}

// eslint-disable-next-line @trello/no-module-logic
export const normalizeBoard = genericNormalizer<BoardResponse, BoardModel>(
  ({ from, has }) => ({
    background: has('prefs', normalizeBoardBackgroundPrefs),
    closed: from('closed'),
    creationMethod: has(
      'creationMethod',
      (method) => method as BoardCreationMethod,
    ),
    dateLastActivity: ({ dateLastActivity }, previousDate) =>
      maxDate(dateLastActivity ?? undefined, previousDate),
    dateLastView: ({ dateLastView }, previousDate) =>
      maxDate(dateLastView ?? undefined, previousDate),
    id: from('id'),
    idOrganization: from('idOrganization'),
    starred: from('starred'),
    enterpriseOwned: from('enterpriseOwned'),
    memberships: membershipsFromResponse,
    name: from('name'),
    prefs: has('prefs', normalizeBoardPrefs),
    premiumFeatures: from('premiumFeatures'),
    shortLink: from('shortLink'),
    url: has('url', (url) => makeLocalUrl(url)),
  }),
);

// eslint-disable-next-line @trello/no-module-logic
export const normalizeBoardStar = genericNormalizer<
  MemberBoardStar,
  BoardStarModel
>(({ from, clientOnly }) => ({
  deleted: clientOnly(),
  id: from('id'),
  idBoard: from('idBoard'),
  pos: from('pos'),
}));
